import { usersRoutesObj, usersBreadcrumbs } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";
import { createRoute } from "@/routes/utils";

const permission = [IRole.STAFF, IRole.SUPER_ADMIN];

const usersRouteMetadata: IRouteMetadataObj<typeof usersRoutesObj> = {
  list: {
    title: "usersManagement",
    lazy: () => import("@/pages/adminPanel/usersManagement/users/table/page"),
    mode: "index",
    permission,
  },
  create: {
    title: "addNewUser",
    lazy: () => import("@/pages/adminPanel/usersManagement/staff/form/page"),
    mode: "create",
    permission,
  },
  edit: {
    title: "editUserOf",
    lazy: () => import("@/pages/adminPanel/usersManagement/staff/form/page"),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewUserOf",
    lazy: () => import("@/pages/adminPanel/usersManagement/staff/form/page"),
    mode: "view",
    permission,
  },
};

export const usersRoutes = createRoute<typeof usersRoutesObj>(
  usersRoutesObj,
  usersRouteMetadata,
  usersBreadcrumbs,
);
